export enum EmptyPageVariant {
  LinkedIn = 'LinkedIn',
  Salesloft = 'Salesloft',
  HubSpot = 'HubSpot',
  MicrosoftDynamics = 'MicrosoftDynamics',
  Salesforce = 'Salesforce',
  Gmail = 'Gmail',
  GoogleSheets = 'GoogleSheets',
}
